<template>
  <div class="ship-popup">
    <div class="cesium-popup-header flex justify-between align-center">
      <span>桥梁信息</span>
      <ElButton circle size="small" @click="props.close">X</ElButton>
    </div>
    <table v-if="properties">
      <tbody>
        <tr v-for="item in tableData" :key="item.key">
          <td class="text-green-800">{{ item.key }}</td>
          <td>{{ item.value }}{{ item.unit ? item.unit : '' }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { ElButton } from 'element-plus'
import type { Bridgedata } from '@/apiFzu/ApiFzu'

const props = defineProps<{
  properties: object
  close(): void
}>()
const properties = computed(() => {
  return props.properties as Bridgedata
})
const tableData = computed(() => {
  const res = [
    {
      key: '名称：',
      value: properties.value.bridge,
    },
    {
      key: '左孔高度：',
      value: properties.value.deckHeightAboveChannelCenterlineleftSpan,
    },
    {
      key: '右孔高度：',
      value: properties.value.deckHeightAboveChannelCenterlinerightSpan,
    },
    {
      key: '通行孔数：',
      value: properties.value.numberOfNavigableSpans,
    },
    {
      key: '完工时间：',
      value: properties.value.completionTime,
      unit: '年',
    },
  ]
  return res.filter((el) => el.value != undefined)
})
</script>
